import React from 'react';
import VideoModal from './VideoModal';
import cx from 'classnames';
import {observer} from 'mobx-react';

@observer
class VideoModalLink extends React.Component {
  componentDidMount = () => {
    if(this.props.externalTriggerId) {
      document.getElementById(
        this.props.externalTriggerId,
      ).addEventListener(
        'click',
        this.onPlayBtnClick,
      );
    }
  };

  onPlayBtnClick = () => {
    this.videoModal.playBtnClicked = true;
  }

  render() {
    const {
      label,
      linkClasses,
      mainPlayBtn,
    } = this.props;

    const videoPlayBtnClasses = cx(linkClasses || 'button play-video', {'main-play-btn': mainPlayBtn});
    const videoPlayIcnClasses = cx('icn cw-icon-play', {'show-for-mobile-only': !mainPlayBtn});

    return (
      <>
        <VideoModal {...this.props} ref={el => this.videoModal = el} />

        <a className={videoPlayBtnClasses} onClick={this.onPlayBtnClick}>
          <span className={videoPlayIcnClasses} />
          {!mainPlayBtn && <span className='video-text'>{label}</span>}
        </a>
      </>
    );
  }
}

export default VideoModalLink;
